import { z } from 'zod';

// The acquisition channel a Lead came in through. Lives in `common/` rather than
// in `lead/` because the Deal detail read carries it too (IMM-456.6's `origin`),
// and `lead/leads.schemas` already imports from `deal/deals.schemas` — a direct
// import back would be a module cycle whose victim is zod's initialisation order,
// not the type checker.
//
// Mirrors CONTACT_SOURCES so a qualified lead's Quelle carries through to the
// Contact unchanged (IMM-193). en-US tokens per ADR 0009; German labels live in
// `packages/i18n`.
export const LEAD_SOURCES = ['MANUAL', 'PARTNER', 'PORTAL', 'WEBSITE', 'REFERRAL', 'COLD_OUTREACH', 'OTHER'] as const;

export const LeadSourceSchema = z.enum(LEAD_SOURCES);

export type LeadSource = z.infer<typeof LeadSourceSchema>;
